<template>      
      <v-layout>
          <v-row dense no-gutters justify="end">
            <v-col style="max-width: 50vw;" :cols="colWidth">
                <v-scroll-x-transition>
                    <v-text-field
                    :label="label"
                    v-model="searchTerm"
                    single-line
                    prepend-inner-icon="mdi-file-search"
                    hide-details="auto" 
                    solo
                    clearable
                    @click:clear="resetSearch()"
                    v-on:keyup="searchChanged()"
                    @focus="searchFocused()"
                    @blur="searchBlurred()"
                    ></v-text-field>
                </v-scroll-x-transition>
            </v-col>
            <v-col style="max-width: 50vw;" v-if="showList && (focused || !focusEffect)" class="ma-0 pa-0" :cols="colWidth">
                <v-list
                v-if="showList && (focused || !focusEffect)"
                class="ma-0 pa-0 scroll-y"
                style="height:150px; overflow-y:auto"
                max-width="100%"
                dense>
                    <v-list-item v-if="loading">
                        <v-progress-circular
                            v-if="loading"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </v-list-item>
                    <v-layout v-if="!loading">
                        <v-row>
                            <v-list-item
                            v-for="(item,i) in searchItems"
                            :key="i"
                            @click="itemClicked(item)"
                            two-line 
                            >
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>
                                    <v-list-item-subtitle v-if="item.ownerName" v-text="`by ${item.ownerName}`"></v-list-item-subtitle>
                                </v-list-item-content>                       

                                <v-list-item-content>
                                    <v-list-item-subtitle v-text="item.dateAdded"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-row>
                    </v-layout>
                </v-list>
            </v-col>
        </v-row>
        <v-dialog v-if="type==='NavBar Search'" v-model="viewTreatmentDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <view-treatment-screen-popup 
            v-if="viewTreatmentDialog"
            v-on:dialogClosed="closeViewTreatment()"
            :treatment="currentShownTreatment.data"
            :treatmentId="currentShownTreatment.id"
            :uid="uid"
            :showToolbar="true">
            </view-treatment-screen-popup>
        </v-dialog>
    </v-layout>
</template>

<script>
import TreatmentDataService from './../../../services/treatmentDataService.js';
import ViewTreatmentScreenPopup from './../Popups/ViewTreatmentScreenPopup.vue'
import Toast from './../../../plugins/customToast.js';
import { algoliaConfig } from './../../../../algolia/algoliaConfig.js';
import algoliaSearch from 'algoliasearch';

  export default {
    data () {
      return {
          searchItems: [],
          currentSelection: {},
          searchTerm: "",
          lastSearchTerm: "",
          loading: false,
          viewTreatmentDialog: false,
          currentShownTreatment: {},
          algConfig: algoliaConfig,
          searchClient: {},
          searchIndex: {},
          treatmentDataService: {},
          focused: false,
          blurCount: 0,
      }
    },
    name: 'quickTreatmentSearch',
    components: {
        ViewTreatmentScreenPopup
    },
    props: 
    {
      label: String,
      type: String,
      uid: String,
      orgId: String,
      focusEffect: Boolean
    },
    beforeCreate() {
        this.$options.components.ViewTreatmentScreenPopup = require('./../Popups/ViewTreatmentScreenPopup.vue').default
    },
    mounted() {
        this.load();
    },
    methods: {
        load(){
            this.treatmentDataService = new TreatmentDataService(this.$route.params.userDb);
            this.searchClient = algoliaSearch(this.algConfig.ALGOLIA_APP_ID, this.algConfig.ALGOLIA_API_KEY);
            this.searchIndex = this.searchClient.initIndex(this.algConfig.ALGOLIA_INDEX_NAME);
        },
        searchChanged(){        
            if (this.validSearch())
            {
                this.searchItems = [];
                this.loading = true;

                this.searchIndex
                .search(this.searchTerm)
                .then(({ hits }) => {
                    if (hits === 0) {
                        this.searchItems.push({id: null, data: {title: "No search results were returned!"}})
                    } else {
                        this.searchItems = hits;
                    }
                    this.loading = false;
                    this.lastSearchTerm = this.searchTerm;
                })
                .catch(err => {
                    console.log(err); //eslint-disable-line
                    this.loading = false;
                });
            }
        },
        itemClicked(item){
        //Need to then search our firebase to get the full object :D
        this.treatmentDataService.searchFirebaseById('treatments', item.objectID).then((fullTreatment) => {
            this.currentSelection = fullTreatment;

            if (this.type === "Case"){
                //If a case one, emit the treatment item
                this.$emit("caseTreatmentEmit", {id: this.currentSelection.id, title: this.currentSelection.data.title, previewImage: this.currentSelection.data.images[0], description: this.currentSelection.data.description, category: this.currentSelection.data.category, ownerName: this.currentSelection.data.ownerName, upvotes: this.currentSelection.data.upvotes, case: this.currentSelection.data.case});
                this.resetSearch();
            } else {
                this.viewTreatment(this.currentSelection);
                this.resetSearch();
            }
        }).catch((error) => {
            //Otherwise, produce the toast error and do nothing
            Toast.fire({  icon: 'error',  title: `Error loading the treatment object! ${error}`});
        });

        
        },
        closeViewTreatment() {
            this.viewTreatmentDialog = false;
        },
        viewTreatment(item) {
            if (item.id != null){
                this.currentShownTreatment = item;
                console.log("Viewing Treatment Item: " + item.data.title + " by " + item.data.ownerName) // eslint-disable-line no-console
                this.viewTreatmentDialog = true;
            }
        },
        searchFocused(){
            this.focused = true;
        },
        searchBlurred(){
            //Called when focus is lost (aka. Blurred)
            //Will not blur on first click off of the search if list is showing
            if (!this.showList || this.blurCount > 1) {
                this.focused = false;
                this.blurCount = 0;
            } else {
                this.blurCount++;
            }
        },
        resetSearch(){
            this.searchTerm = "";
            this.lastSearchTerm = "";
            this.searchItems = [];
        },
        validSearch(){
        //Remove any spaces to stop searching on loads of empty spaces added
        var shrunkSearchTerm = this.searchTerm.replace(" ", "");

        //First check if the search term is empty, if so, reset the dialog
        if (shrunkSearchTerm.length === 0){
            this.resetSearch();
            return false;
        } else {
            //Then, check if the search has changed since the last call of this?
            if (this.searchTerm === this.lastSearchTerm){
                //Do not do the search again
                return false;
            } else {
                //Otherwise, you can search as normal, so return true and update the 'lastSearchTerm'
                this.lastSearchTerm = this.searchTerm;
                return true;
            }
        }
      },
    },
     computed: {
         showList(){
            if (this.searchItems.length > 0){
                return true;
            } else if (this.loading){
                return true;
            } else {
                return false;
            }
         },
         colWidth(){
            if (!this.focused && this.focusEffect) {
                return "3";
            }
            return "12";
         },
    }
  }
</script>

<style scoped>
.v-container {
    max-width: 50px;
}
</style>